import type { ReactMarkdownProps } from 'react-markdown/lib/complex-types';
import { RichTextBlockQuote } from './MarkdownComponents.styles';

export function BlockQuote({ children }: ReactMarkdownProps) {
  return <RichTextBlockQuote>{children}</RichTextBlockQuote>;
}
